import PropTypes from 'prop-types';
import cn from 'classnames';
import React, {Component} from 'react';
import css from './css.css';
import commoncss from '~/themes/common.css';
import TableToggle from "~/ui/TableActionBar/TableToggle";
import SearchFilter from "~/ui/TableActionBar/SearchFilter";
import FilterMenu from "~/ui/TableActionBar/FilterMenu";
import TableActions from "~/ui/TableActionBar/TableActions";
import TableSettings from "~/ui/TableActionBar/TableSettings";

import { Center, HStack, IconButton, Portal, ScrollView, } from '~/native-ui';
import { FilteredViews, SaveFilteredViews } from '~/ui/FilteredViews';
import Bar from '../../components/Bar/Bar';


export default class TableActionBar extends Component {
    static propTypes = {
        modelId: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        addText: PropTypes.string.isRequired,
        onAdd: PropTypes.func.isRequired,
        onClose: PropTypes.func.isRequired,
        parentModelId: PropTypes.string,
        canCreate: PropTypes.bool.isRequired
    };

    triggerProps = { ml: "1" }
    leftActions = () => {
        if (!this.props.parentModelId) {
            return (
                <HStack space="2" alignItems="center">
                    <HStack alignItems="center">
                        <FilteredViews modelId={this.props.modelId} />
                        {/* <FilterMenu modelId={this.props.modelId} triggerProps={this.triggerProps} placement="bottom left" /> */}
                        <TableSettings modelId={this.props.modelId} />
                        <TableToggle modelId={this.props.modelId} />
                    </HStack>
                    <SaveFilteredViews modelId={this.props.modelId} />
                </HStack>
            );
        }

        return (
            <Center width={40}>
                <IconButton
                    icon="arrow_back"
                    className={cn(commoncss.goBack, css.goBack)}
                    primary
                    onClick={this.props.onClose}
                />
            </Center>
        );
    };
    

    contentContainerStyle = {marginLeft: "auto", alignItems: "center"}
    rightActions = () => {
        return (
                <HStack pr="4">
                    <ScrollView horizontal ml="auto" contentContainerStyle={this.contentContainerStyle}>
                        {/* <SearchFilter modelId={this.props.modelId} /> */}
                        <TableActions
                            modelId={this.props.modelId}
                            canCreate={this.props.canCreate}
                            addText={this.props.addText}
                            onAdd={this.props.onAdd}
                            createTooltip={this.props.createTooltip}
                        />
                    </ScrollView>
                </HStack>
        );
    };
    
    render() {
        return <Bar shadow="1" px="4" py="2" space="2" left={this.leftActions()} right={this.rightActions()} />
    }
}